import { StrictMode } from "react";
import ReactDOM from "react-dom";
import React, { useEffect, useRef, useState } from "react";

import {
  Link,
  DirectLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from "react-scroll";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

// COMPONENTS
import Platinum from "../platinum/platinum";
import HomeText from "../homeText/homeText";
import Footer from "../footer/footer";
import Header from "../header/header";
import FirstComp from "./firstComp";
import SecondComp from "./secondComp";
import ThirdComp from "./thirdComp";
import FourthComp from "./fourthComp";
import FifthComp from "./fifthComp";

// CSS
import "./home.css";
import "./homepage.css";

//RESOURCES
import Img1 from "../../images/imgComp/imgComp1.webp";
import Img2 from "../../images/imgComp/imgComp2.webp";
import Img3 from "../../images/imgComp/imgComp3.webp";
import Img4 from "../../images/imgComp/imgComp4.webp";
import Img5 from "../../images/imgComp/imgComp5.webp";

import nav1 from "./images/navImgs/img1.svg";
import nav2 from "./images/navImgs/img2.svg";
import nav3 from "./images/navImgs/img3.svg";
import nav4 from "./images/navImgs/img4.svg";
import nav5 from "./images/navImgs/img5.svg";

import bg from "../../images/bg.webp";
import Home from "../navigation/images/home.svg";
import Back from "../navigation/images/back.svg";
import Forward from "../navigation/images/forward.svg";
//TILT
import Tilt from "react-parallax-tilt";
import EmeraldCut from "./images/emeraldc.svg";
import EmeraldModel from "./images/emerald.webp";
import PrincessCut from "./images/princessc.svg";
import PearCut from "./images/pearc.svg";
import MarquiseCut from "./images/marquisec.svg";
import OvalCut from "./images/ovalc.svg";
import PrincessModel from "./images/princess.webp";
import PearModel from "./images/pear.webp";
import MarquiseModel from "./images/marquise.webp";
import OvalModel from "./images/oval.webp";

export default function ContentPage() {
  gsap.registerPlugin(ScrollTrigger);
  useEffect(() => {
    gsap.set(navRef, {
      y: 100
    });
  });
  useEffect(() => {
    gsap.to(navRef, {
      y: 0,
      scrollTrigger: {
        start: "bottom bottom",
        end: "bottom",
        trigger: trigger,
        toggleActions: "play none none reverse"
      }
    });
  });
  let navRef = useRef(null);
  let trigger = useRef(null);
  return (
    <div>
      {/* MAIN COMPONENTS */}
      <div className="scroll-trigger" ref={(el) => (trigger = el)}></div>
      <Header />
      <div className="mainContainer " style={{ backgroundImage: `url(${bg})` }}>
        <Platinum />
        <div className="emerald-comp">
          <div class="multiple-tilt">
            <Link
              spy={true}
              smooth={true}
              duration={1000}
              activeClass="active"
              to="princess"
            >
              <Tilt
                className="parallax-effect-img princessm"
                tiltMaxAngleX={0}
                tiltMaxAngleY={40}
                perspective={800}
                transitionSpeed={1500}
                scale={1.1}
                gyroscope={true}
                trackOnWindow={false}
                style={{
                  backgroundImage: `url(${PrincessModel})`
                }}
              >
                <span class="title-cut-home">PRINCESS</span>
                <img
                  src={PrincessCut}
                  className="inner-element princessc"
                  alt="pic"
                />
              </Tilt>
            </Link>
            <Link
              spy={true}
              smooth={true}
              duration={1000}
              activeClass="active"
              to="pear"
            >
              <Tilt
                className="parallax-effect-img"
                tiltMaxAngleX={0}
                tiltMaxAngleY={40}
                perspective={800}
                transitionSpeed={1500}
                scale={1.1}
                gyroscope={true}
                trackOnWindow={false}
                style={{ backgroundImage: `url(${PearModel})` }}
              >
                <span class="title-cut-home">PEAR</span>
                <img src={PearCut} className="inner-element pearc" alt="pic" />
              </Tilt>
            </Link>

            <Link
              spy={true}
              smooth={true}
              duration={1000}
              activeClass="active"
              to="marquise"
            >
              <Tilt
                className="parallax-effect-img marquisem"
                tiltMaxAngleX={0}
                tiltMaxAngleY={40}
                perspective={800}
                transitionSpeed={1500}
                scale={1.1}
                gyroscope={true}
                trackOnWindow={false}
                style={{
                  backgroundImage: `url(${MarquiseModel})`
                }}
              >
                <span class="title-cut-home">MARQUISE</span>
                <img
                  src={MarquiseCut}
                  className="inner-element marquisec"
                  alt="pic"
                />
              </Tilt>
            </Link>
            <Link
              spy={true}
              smooth={true}
              duration={1000}
              activeClass="active"
              to="emerald"
            >
              <Tilt
                className="parallax-effect-img emeraldm"
                tiltMaxAngleX={0}
                tiltMaxAngleY={40}
                perspective={800}
                transitionSpeed={1500}
                scale={1.1}
                gyroscope={true}
                trackOnWindow={false}
                style={{
                  backgroundImage: `url(${EmeraldModel})`
                }}
              >
                <span class="title-cut-home">EMERALD</span>
                <img
                  src={EmeraldCut}
                  className="inner-element emeraldc"
                  alt="pic"
                />
              </Tilt>
            </Link>
            <Link
              spy={true}
              smooth={true}
              duration={1000}
              activeClass="active"
              to="oval"
            >
              <Tilt
                className="parallax-effect-img ovalm"
                tiltMaxAngleX={0}
                tiltMaxAngleY={40}
                perspective={800}
                transitionSpeed={1500}
                scale={1.1}
                gyroscope={true}
                trackOnWindow={false}
                style={{ backgroundImage: `url(${OvalModel})` }}
              >
                <span class="title-cut-home">OVAL</span>
                <img src={OvalCut} className="inner-element ovalc" alt="pic" />
              </Tilt>
            </Link>
          </div>
        </div>
        <HomeText />
      </div>

      <div
        className="div-ref-scroll "
        // ref={(el) => (princessRef = el)}

        id="princess"
      ></div>
      <FirstComp />
      <div
        className="div-ref-scroll"
        // ref={(el) => (pearRef = el)}
        id="pear"
      ></div>
      <SecondComp />
      <div
        className="div-ref-scroll"
        // ref={(el) => (marqRef = el)}
        id="marquise"
      ></div>
      <ThirdComp />
      <div
        className="div-ref-scroll"
        // ref={(el) => (emeraldRef = el)}
        id="emerald"
      ></div>
      <FourthComp />
      <div
        className="div-ref-scroll"
        // ref={(el) => (ovalRef = el)}
        id="oval"
      ></div>
      <FifthComp />
      <Footer />

      {/* NAVIGATION */}
      <div className="navigation-main" ref={(el) => (navRef = el)}>
        <div className="navigation-grid">
          <div className="nav-elem">
            <div className="nav-elem-container">
              <Link
                spy={true}
                smooth={true}
                duration={1000}
                activeClass="active"
                to="princess"
              >
                <img src={nav1} alt="" />
              </Link>
            </div>
          </div>
          <div className="nav-elem">
            <div className="nav-elem-container">
              <Link
                spy={true}
                smooth={true}
                duration={1000}
                activeClass="active"
                to="pear"
              >
                <img src={nav2} alt="" />
              </Link>
            </div>
          </div>
          <div className="nav-elem">
            <div className="nav-elem-container">
              <Link
                spy={true}
                smooth={true}
                duration={1000}
                activeClass="active"
                to="marquise"
              >
                <img src={nav3} alt="" />
              </Link>
            </div>
          </div>
          <div className="nav-elem">
            <div className="nav-elem-container">
              <Link
                spy={true}
                smooth={true}
                duration={1000}
                activeClass="active"
                to="emerald"
              >
                <img src={nav4} alt="" />
              </Link>
            </div>
          </div>
          <div className="nav-elem">
            <div className="nav-elem-container">
              <Link
                spy={true}
                smooth={true}
                duration={1000}
                activeClass="active"
                to="oval"
              >
                <img src={nav5} alt="" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
